/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ free: NonNullable<unknown> }} New_User_Paywall_Title_Free_VerInputs */

const en_new_user_paywall_title_free_ver = /** @type {(inputs: New_User_Paywall_Title_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Try Plus for ${i?.free}`)
};

const ar_new_user_paywall_title_free_ver = /** @type {(inputs: New_User_Paywall_Title_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`جرب بلس ${i?.free}`)
};

const de_new_user_paywall_title_free_ver = /** @type {(inputs: New_User_Paywall_Title_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus ${i?.free} testen`)
};

const es_new_user_paywall_title_free_ver = /** @type {(inputs: New_User_Paywall_Title_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prueba Plus ${i?.free}`)
};

const fr_new_user_paywall_title_free_ver = /** @type {(inputs: New_User_Paywall_Title_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Essayez Plus ${i?.free}`)
};

const it_new_user_paywall_title_free_ver = /** @type {(inputs: New_User_Paywall_Title_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prova Plus ${i?.free}`)
};

const ja_new_user_paywall_title_free_ver = /** @type {(inputs: New_User_Paywall_Title_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plusを${i?.free}お試し`)
};

const ko_new_user_paywall_title_free_ver = /** @type {(inputs: New_User_Paywall_Title_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus를 ${i?.free}로 체험해 보세요`)
};

const pt_br_new_user_paywall_title_free_ver = /** @type {(inputs: New_User_Paywall_Title_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Experimente o Plus ${i?.free}`)
};

const ru_new_user_paywall_title_free_ver = /** @type {(inputs: New_User_Paywall_Title_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Попробуйте Plus ${i?.free}`)
};

const th_new_user_paywall_title_free_ver = /** @type {(inputs: New_User_Paywall_Title_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ทดลองใช้ Plus ${i?.free}`)
};

const tr_new_user_paywall_title_free_ver = /** @type {(inputs: New_User_Paywall_Title_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus'ı ${i?.free} dene`)
};

const zh_cn_new_user_paywall_title_free_ver = /** @type {(inputs: New_User_Paywall_Title_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free}试用 Plus`)
};

const zh_tw_new_user_paywall_title_free_ver = /** @type {(inputs: New_User_Paywall_Title_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free}試用 Plus`)
};

/**
* | output |
* | --- |
* | "Try Plus for {free}" |
*
* @param {New_User_Paywall_Title_Free_VerInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const new_user_paywall_title_free_ver = /** @type {((inputs: New_User_Paywall_Title_Free_VerInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_User_Paywall_Title_Free_VerInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_new_user_paywall_title_free_ver(inputs)
	if (locale === "ar") return ar_new_user_paywall_title_free_ver(inputs)
	if (locale === "de") return de_new_user_paywall_title_free_ver(inputs)
	if (locale === "es") return es_new_user_paywall_title_free_ver(inputs)
	if (locale === "fr") return fr_new_user_paywall_title_free_ver(inputs)
	if (locale === "it") return it_new_user_paywall_title_free_ver(inputs)
	if (locale === "ja") return ja_new_user_paywall_title_free_ver(inputs)
	if (locale === "ko") return ko_new_user_paywall_title_free_ver(inputs)
	if (locale === "pt_br") return pt_br_new_user_paywall_title_free_ver(inputs)
	if (locale === "ru") return ru_new_user_paywall_title_free_ver(inputs)
	if (locale === "th") return th_new_user_paywall_title_free_ver(inputs)
	if (locale === "tr") return tr_new_user_paywall_title_free_ver(inputs)
	if (locale === "zh_cn") return zh_cn_new_user_paywall_title_free_ver(inputs)
	return zh_tw_new_user_paywall_title_free_ver(inputs)
});